import vtkRenderWindow from './RenderWindow';

export default {
  vtkRenderWindow,
};
